export default "__VITE_ASSET__DYs3fKuj__"